import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import svg from 'assets/svg'

const View = props => {
  const { intl } = props

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'theming-view1-view-title' })}
      subTitle={{
        subtitle: intl.formatMessage({
          id: 'theming-view1-subtitle'
        }),
        icon: svg.lightBulb
      }}
    >
      theme view 1
    </MainContentWrapper>
  )
}

View.propTypes = {
  intl: PropTypes.shape().isRequired
}

export default injectIntl(View)
